import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { overlayStyles as styles } from './styles'
import SwiftypeSearch from './SwiftypeSearch'

const SwiftypeSearchContainer = ({ programmeSearchIsActive }) => (
  programmeSearchIsActive
    ? (
      <div className="overlay-container" id="overlay-container">
        <SwiftypeSearch />
        <style jsx>{styles}</style>
      </div>
    ) : ''

)

SwiftypeSearchContainer.propTypes = {
  programmeSearchIsActive: PropTypes.bool,
}

SwiftypeSearchContainer.defaultProps = {
  programmeSearchIsActive: false,
}

const mapStateToProps = state => ({
  programmeSearchIsActive: state?.programmeSearch?.isActive,
})

export default connect(mapStateToProps)(SwiftypeSearchContainer)
